import { css } from '@emotion/react';
import { Button, Flex, Text, Title } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

import { AUTH_URL } from '../../../../../constants/urls';

interface EmptyAccountProps {
  onRetry: () => void;
}

export function EmptyAccount({ onRetry }: EmptyAccountProps) {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={32} w="100%">
      <Flex direction="column" gap={12}>
        <Title order={2} ta="center">
          {t('아이디(이메일) 찾기')}
        </Title>
        <Text size="md" ta="center">
          {t('계정에 등록된 휴대폰 번호가 없습니다.')}
          <br />
          {t('다른 번호를 입력하시거나 회원가입해 주세요.')}
        </Text>
      </Flex>
      <Flex gap={8}>
        <Button
          variant="default"
          size="md"
          styles={{
            root: styleButton,
          }}
          onClick={onRetry}
        >
          {t('다시 찾기')}
        </Button>
        <Button
          component={Link}
          href={AUTH_URL.SIGNUP()}
          variant="filled"
          size="md"
          styles={{
            root: styleButton,
          }}
        >
          {t('회원가입')}
        </Button>
      </Flex>
    </Flex>
  );
}

const styleButton = css({
  flex: 1,
});
